import { getAxiosInstance } from "../ApiConfig";

async function getCompanyCase() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCasebuReportingUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getFollowingCasebyUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllCasePaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllCaseSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCaseByReportingRoleUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllFCasePaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllFCaseearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCaseByFollowers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchCaseDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByCase/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCase(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCase/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createCase(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCase`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteCase(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCase/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllCaseByLead(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByLead/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCaseByContact(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByContact/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCaseByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCaseByAccount/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    findAllCaseByLead,
    findAllCaseByContact,
    findAllCaseByAccount,
    getCasebuReportingUser,
    getCompanyCase,
    FetchCaseDetails,
    getFollowingCasebyUser,
    updateCase,
    deleteCase,
    createCase,
    AllCasePaginationSearch,
    AllCaseSearch,
    AllFCasePaginationSearch,
    AllFCaseearch
}